export default "__VITE_ASSET__BlowzQUT__"